







































import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {}
})
export default class SwiperPartner extends Vue {
  list = [
    {
      src:
        "background-image:url('" + require("../../../assets/hzwl.jpg") + "')",
      names: "专家权益"
    },
    {
      src:
        "background-image:url('" + require("../../../assets/hzqy.jpg") + "')",
      names: "常见问题"
    },
    {
      src:
        "background-image:url('" + require("../../../assets/hzcj.jpg") + "')",
      names: "申请加入"
    }
  ];
  SwiperPartner = {
    // slidesPerView: 3, // 每页显示几个slide
    // spaceBetween: 50,
    // centeredSlides: true,
    centeredSlidesBounds: true,
    direction: "horizontal",
    loop: true,
    autoplay: true,
    centeredSlides: true,
    slidesPerView: 3,
    spaceBetween: "5%",
    effect: "coverflow",
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 0,
      modifier: 2,
      slideShadows: false
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    breakpoints: {
      //当宽度大于等于320
      320: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      //当宽度大于等于480
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      //当宽度大于等于640
      640: {
        slidesPerView: 2,
        spaceBetween: 30
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 50
      },
      1366: {
        slidesPerView: 3,
        spaceBetween: 90
      }
    }

    // navigation: {
    //   nextEl: '.swiper-button-next',
    //   prevEl: '.swiper-button-prev',
    // },
    // loop: false,
    // autoplay: false,
  };
  mounted() {
    // console.log(this.list);
  }
  // props: ["list"],
}
